import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store';

import authRoutes from './routes/authRoutes';
import dashboardRoutes from './routes/dashboardRoutes';
import devicesRoutes from './routes/devicesRoutes';
import reportRoutes from './routes/reportRoutes';
import usersRoutes from './routes/usersRoutes';
import settingsRoutes from './routes/settingsRoutes';
import managementRoutes from './routes/managementRoutes';

const routes = [
  ...authRoutes,
  ...dashboardRoutes,
  ...devicesRoutes,
  ...reportRoutes,
  ...usersRoutes,
  ...settingsRoutes,
  ...managementRoutes,
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters["auth/isAuthenticated"];
  const user = store.getters["auth/getUser"];
  const userRole = user?.role?.name;

  if (to.meta.requiresAuth && !isAuthenticated) {
    return next('/login');
  }

  if (to.name === 'LoginPage' && isAuthenticated) {
    return next('/dashboard');
  }

  if (to.meta.roles && !to.meta.roles.includes(userRole)) {
    return next('/dashboard');
  }

  return next();
});

export default router;
